import React, { useState, useEffect, useReducer, Suspense } from 'react'
import { Link } from 'react-router-dom'
import Helmet from 'react-helmet'
import SuspenseLoader from '../../components/suspense_loader/SuspenseLoader'
import { fetchDataWithHooks } from '../../utils/js/fetch_helpers'

function stateReducer(state, action) {
    switch (action.type) {
        case 'UPDATE_POST_FETCH_STATE':
            return {
                activeIndex: action.activeIndex,
                endpointData: action.endpointData,
                initLoad: false,
            }
        default:
            throw new Error()
    }
}

export const TabsAndPages = ({ initStateData = {}, pageData = {} }) => {
    const [state, dispatch] = useReducer(stateReducer, initStateData)
    const [isError, setError] = useState(false)
    const [isFetching, setFetching] = useState(true)

    let pageBasic = ''
    if (window.SNLiveTracker.basic) pageBasic = '?template=basic'

    let newActiveIndex = null
    pageData.forEach((item, i) => {
        if (item.active === true) newActiveIndex = i
    })

    const shownTabsDataLength = pageData.filter(item => item.show_tab === true).length
    const showTabbingAnimation = newActiveIndex < shownTabsDataLength

    const activeTabPosition = showTabbingAnimation ? 100 * newActiveIndex : 0
    const activeTabWidth = showTabbingAnimation ? 100 / shownTabsDataLength : 0
    const activeTabOpacity = showTabbingAnimation ? 1 : 0

    const ActiveComponent = pageData[state.activeIndex].component

    const setNewData = arg => {
        let activeIndex = null
        pageData.forEach((item, i) => {
            if (item.active === true) activeIndex = i
        })

        dispatch({
            type: 'UPDATE_POST_FETCH_STATE',
            activeIndex: activeIndex,
            endpointData: arg,
            initLoad: false,
        })
    }

    useEffect(() => {
        setFetching(true)

        fetchDataWithHooks(
            pageData[newActiveIndex].init_endpoint,
            setNewData,
            setFetching,
            setError
        )
    }, [newActiveIndex + pageData[newActiveIndex].init_endpoint])

    useEffect(() => {
        let links = document.querySelectorAll('.ripple_tab_link')

        for (var i = 0, len = links.length; i < len; i++) {
            links[i].addEventListener(
                'click',
                function(e) {
                    let targetEl = e.target
                    let inkEl = targetEl.querySelector('.ink')

                    if (inkEl) {
                        inkEl.classList.remove('animate_ripple')
                    } else {
                        inkEl = document.createElement('span')
                        inkEl.classList.add('ink')
                        inkEl.style.width = inkEl.style.height =
                            Math.max(targetEl.offsetWidth, targetEl.offsetHeight) + 'px'
                        targetEl.appendChild(inkEl)
                    }

                    inkEl.style.left = e.offsetX - inkEl.offsetWidth / 2 + 'px'
                    inkEl.style.top = e.offsetY - inkEl.offsetHeight / 2 + 'px'
                    inkEl.classList.add('animate_ripple')
                },
                false
            )
        }
    }, [])

    if (isError) {
        return (
            <div className="TradeSigningsTracker__cont">
                Unfortunately, An Error Has Occurred. Please Try Again.
            </div>
        )
    }

    return (
        <React.Fragment>
            <div className="tabs_cont" id="tabs_cont">
                <div
                    className="active_tab_slider"
                    style={{
                        transform: `translate3d(${activeTabPosition}%, 0, 0)`,
                        width: `${activeTabWidth}%`,
                        opacity: activeTabOpacity,
                    }}
                ></div>

                <div className="tabs_cont_inner">
                    {pageData.map((item, i) => (
                        <React.Fragment key={item.page_name + i.toString()}>
                            {item.active && <PageHelmet {...item} />}
                            {item.show_tab && (
                                <div className={`tab_cont ${item.active ? 'active' : ''}`}>
                                    <div
                                        className={`ripple_tab_link tab_cont_inner ${(item.active &&
                                            'active') ||
                                            ''}`}
                                    >
                                        <Link
                                            to={`/${item.sport}/${item.league}/${item.page}${pageBasic}`}
                                        >
                                            {item.display_name}
                                        </Link>
                                    </div>
                                </div>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </div>

            {!state.initLoad && (
                <Suspense fallback={<SuspenseLoader />}>
                    <ActiveComponent data={state.endpointData} isFetching={isFetching} />
                </Suspense>
            )}
            {state.initLoad && (
                <div>
                    <SuspenseLoader />
                </div>
            )}
        </React.Fragment>
    )
}

export const PageHelmet = ({ sport = '', league = '', page = '', display_name = '' }) => {
    return (
        <Helmet
            title={`${league.toUpperCase()} ${display_name} - Sportsnet.ca`}
            link={[
                {
                    rel: 'canonical',
                    href: `${window.location.origin}/${sport}/${league}/${page}`,
                },
            ]}
        />
    )
}
